import {
  Corset,
  CORSET_BY_CODE,
  DeviceModelCode,
} from '../enums';

// * DEVICE COMMONS

// flags individuales
export const isAtlasModel = (model?: number | null): boolean =>
  model === DeviceModelCode.ATLAS;

export const isExplorerPersonalModel = (model?: number | null): boolean =>
  model === DeviceModelCode.EXPLORER_PERSONAL;

export const isExplorerClinicModel = (model?: number | null): boolean =>
  model === DeviceModelCode.EXPLORER_CLINICO;


// istanbul ignore next
export function getCorsetFromNumber(value: number): Corset | undefined {
  return CORSET_BY_CODE[value];
}
